import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Widget } from '@cms/interfaces/widget';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

library.add(faSync);

@Component({
  name: 'bpc-widget-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class WidgetTable extends mixins(AbstractTable) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: Widget = null;
  public entityName = 'widget';
  public pluralEntityName = 'widgets';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  setEntityAttributesAfterSave() {
    const newEntity = {} as Widget;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'published', this.entity.published);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onShow(e) {
    this.$bvModal.show('modal-widget-details');
    this.entity = e.item;
  }

  onModelLoaded() {
    /* if (this.$refs.stdForm.formModel.id && 
        this.$refs.stdForm.formModel.type === 'entity' &&
        this.$refs.stdForm.formModel.entity) {
      setTimeout(() => {
        this.$root.$emit('updateEntitySelectOnLoad', this.$refs.stdForm.formModel.entity);
      });
    } */
  }

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
